import { createStore, applyMiddleware } from 'redux';
import rootReducer from './index';
import thunk from 'redux-thunk';

let store

if (process.env.REACT_APP_SLOT === 'production' || process.env.REACT_APP_SLOT === "PROD") {
    //console.log("NODE ENVIRONMENT: ", process.env.NODE_ENV);
    store = createStore(
        rootReducer,
        applyMiddleware(thunk)
    )
} else {
    store = createStore(
        rootReducer,
        applyMiddleware(thunk)
        // composeWithDevTools(applyMiddleware(thunk, logger))
    )
}

// const store = createStore(
//     rootReducer,
//     composeWithDevTools(applyMiddleware(thunk, logger))
// );

export default store as any;